import { useIsIcebergMetricsEnabled } from "src/hooks/useIsIcebergMetricsEnabled";
import { PerformanceContent } from "src/performance/PerformanceContent";
import { PerformanceContentIceberg } from "src/performance/PerformanceContentIceberg";

/**
 * Router component that switches between Aurora and Iceberg performance implementations
 * based on the readDHv2 OR enable_dhv2_metrics feature flag OR workspace history_mode setting
 */
export const PerformanceRouter: React.FC = () => {
  const useIcebergMetrics = useIsIcebergMetricsEnabled();

  return useIcebergMetrics ? (
    <PerformanceContentIceberg />
  ) : (
    <PerformanceContent />
  );
};
